<section class="nuestros px-4 px-xxl-5">
  <div class="content-page">
    <div class="user-img ">
      <img src="/assets/svg/icon-user.svg" alt="user">
      <span class="title">Nuestros aliados</span>
    </div>
  </div>
</section>
<section class="media px-4 px-xxl-5">
  <div class="content-page">
    <h2 class="title1 fw-bold fs-sm-7 fs-md-4 mb-0">Alianzas sólidas que respaldan tu patrimonio</h2>
    <span class="span fw-light fs-sm-7 fs-md-6">Te conectamos con instituciones financieras de prestigio internacional.
      No
      recibimos fondos de forma directa; te acompañamos en la apertura de tu cuenta, póliza o inversión a tu nombre con
      nuestros aliados estratégicos, asegurando la transparencia y el respaldo de entidades con regulación estricta y
      trayectoria comprobada.</span>
  </div>
  <div class="images content-page row text-center">
    <swiper-container #swiperEl slides-per-view="4" space-between="20" loop="true"
      autoplay-disable-on-interaction="false" breakpoints='{
      "0": { "slidesPerView": 2 },
      "768": { "slidesPerView": 2 },
      "1024": { "slidesPerView": 3 },
      "1200": { "slidesPerView": 4 }
    }'>
      <swiper-slide *ngFor="let logo of partners">
        <img [src]="logo" alt="logo" class="w-100" />
      </swiper-slide>
    </swiper-container>
  </div>
</section>
<section class="nuestros reguladores px-4 px-xxl-5">
  <div class="content-page">
    <div class="user-img">
      <img src="/assets/svg/icon-shield.svg" alt="user">
      <span class="title">Reguladores</span>
    </div>
  </div>
</section>
<section class="media reguladores px-4 px-xxl-5">
  <div class="content-page">
    <h2 class="title1 fw-bold fs-sm-7 fs-md-4 mb-0">Regulación que marca el estándar de nuestros aliados</h2>
    <span class="span fw-light fs-sm-7 fs-md-6">Todos nuestros aliados operan bajo la supervisión de sólidas entidades
        reguladoras en diversos países, cumpliendo con marcos legales estrictos que garantizan transparencia,
        seguridad
        y las mejores prácticas de la industria.</span>
  </div>
  <div class="images content-page row text-center">
    <swiper-container #swiperEl slides-per-view="4" space-between="20" loop="true"
      autoplay-disable-on-interaction="false" breakpoints='{
      "0": { "slidesPerView": 2 },
      "768": { "slidesPerView": 2 },
      "1024": { "slidesPerView": 3 },
      "1200": { "slidesPerView": 4 }
    }'>
      <swiper-slide *ngFor="let logo of certificaciones">
        <img [src]="logo" alt="logo" class="w-100" />
      </swiper-slide>
    </swiper-container>
  </div>
</section>
<section class="texto px-4 px-xxl-5">
  <div class="text1">
    <span class="fw-light fs-sm-7 fs-md-5"> En un mundo lleno de opciones, elegimos la excelencia. Diseñamos estrategias
      sólidas, con la dedicación y el rigor que tu capital merece, para transformar la planificación en libertad y
      legado.
    </span>
  </div>
</section>